import React, { Component } from 'react';
import { Translate, Icon } from '$common';
import CSSModules from 'react-css-modules';
import style from './layout.scss';
import { Link } from 'react-router';

@CSSModules(style)
export default class Layout extends Component {

  state = {
    currentRouteName: window.location.pathname.split('/')
  };

  componentWillReceiveProps(props) {
    this.setState({ currentRouteName: window.location.pathname.split('/') });
  }

  render() {
    const { onLogout } = this.props;
    const { currentRouteName } = this.state;

    return (
      <div styleName="root">
        <div styleName="navigation">
          <ul>
            <li styleName={currentRouteName[2] === "edit" ? 'active' : ''}><Link to="/account/edit">{Translate.get('edit_profile')}</Link></li>
            <li styleName={currentRouteName[2] === "reports" ? 'active' : ''}><Link to="/account/reports">{Translate.get('reports')}</Link></li>
            <li styleName="logout"><a onClick={onLogout} id="live-sign-out-button">{Translate.get('logout')} <Icon name="sign-out" /></a></li>
          </ul>
        </div>

        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account/layout.js